readQuery